module.exports = __webpack_public_path__ + "img/chat.468f8175.svg";